import React from 'react';
import ReactDOM from 'react-dom';
import Index from './views/index';
import './index.css';

ReactDOM.render(
  <Index />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js